// extracted by mini-css-extract-plugin
export default {"gcMap":"HealthMap_gcMap__3tuEw"};